module.exports = __webpack_public_path__ + "img/zhuanli.65c4051e.png";